import { AccountService } from './account.service';
import CartService from './cart.service';
import { ContentfulService } from './contentful.service';
import { DoctorProfileService } from './doctorProfile.service';
import { ProductService } from './product.service';
import { TaxonService } from './taxon.service';
import { CheckoutService } from './checkout.service';
import { CustomClamshellService } from './customClamshell.service';
import { DesignHuddleService } from './designhuddle.service';
import { MarketingProjectService } from './marketingProject.service';
import {
  IteroCartService,
  IteroProductService,
  IteroCheckoutService,
  IteroProposalService,
} from './itero';
import { ProductCacheService } from './productCache.service';
import { SubscriptionService } from './subscription.service';
import { Auth0UserService } from './auth0User.service';
import {
  DsoCartService,
  DsoCheckoutService,
  DsoOrderHistoryService,
  DsoOrderDetailsService,
  DsoTaxonService,
  DsoProductService,
  DsoIdsStoreSettingsService,
} from './dso/index';

export const cartService = new CartService();
export const doctorProfileService = new DoctorProfileService();
export const contentfulService = new ContentfulService();
export const productService = new ProductService();
export const taxonService = new TaxonService();
export const accountService = new AccountService();
export const checkoutService = new CheckoutService();
export const customClamshellService = new CustomClamshellService();
export const designHuddleService = new DesignHuddleService();
export const marketingProjectService = new MarketingProjectService();
export const iteroProductService = new IteroProductService();
export const iteroCartService = new IteroCartService();
export const iteroProposalService = new IteroProposalService();
export const iteroCheckoutService = new IteroCheckoutService();
export const productCacheService = new ProductCacheService();
export const subscriptionService = new SubscriptionService();
export const auth0UserService = new Auth0UserService();
export const dsoCartService = new DsoCartService();
export const dsoCheckoutService = new DsoCheckoutService();
export const dsoOrderHistoryService = new DsoOrderHistoryService();
export const dsoOrderDetailsService = new DsoOrderDetailsService();
export const dsoTaxonService = new DsoTaxonService();
export const dsoProductService = new DsoProductService();
export const dsoIdsStoreSettingsService = new DsoIdsStoreSettingsService();
